import React,{ Component } from 'react';

class NoItems extends Component {
	
  render() {
    return (
    	<div className="alert alert-warning text-center">	
    		{this.props.text}
    	</div>
    );
  }
  
}


export default NoItems;
